import type { BoardSortHint } from "./Board.types";
import type { BoardSlotEdge } from "./useBoardSlotSpot";

/** The hint's title while the slot is scrolled past that edge of the column's view. */
export const SORT_HINT_EDGE_TITLES: Record<BoardSlotEdge, string> = {
    above: "Lands above ↑",
    below: "Lands below ↓",
};

/** The hint's second line: how to place by hand, or why the held spot can't take the card. */
export const getSortHintCopy = (
    sortHint: BoardSortHint | undefined,
    {
        canPlaceBetween,
        placeRefusal,
    }: { canPlaceBetween: boolean; placeRefusal: string | undefined },
): BoardSortHint | undefined => {
    if (sortHint === undefined) {
        return undefined;
    }
    if (!canPlaceBetween) {
        return { title: sortHint.title };
    }
    return placeRefusal === undefined
        ? sortHint
        : { title: sortHint.title, placeLabel: placeRefusal };
};
